import { EntityType } from '@frontend/common';
import { IoTExtendedClient } from '@frontend/iot/api';
import { iotRequest } from '@frontend/iot/events';
import { IoT, IoTExtended } from '@frontend/iot/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import { IOT_SETTINGS_LABEL, IoTDetailsCard, IoTGeneralSection, IoTSettingsSection } from './iot-detail-sections';

export const iotReactiveDetail: ReactiveDetailRegistryEntry<IoT, IoTExtended> = {
    entityType: EntityType.IOT,
    resolveFunction: iotRequest,
    fetchExtended: ({ object }) => IoTExtendedClient.fetchIoTExtended(object.account_id, object.id),
    modalClassName: 'w-full lg:w-2/3 max-w-[900px]',
    title: ({ object, extended }) => (
        <div className='flex gap-1'>
            <span>{CommonMessage.OBJECTS.IOT.ASSET.DEFAULT}:</span>
            <span>{extended?.name ?? object.name}</span>
        </div>
    ),
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: (view) =>
                view.extended ? (
                    <>
                        <IoTDetailsCard iot={view.extended} />
                        <IoTGeneralSection iot={view.extended} />
                    </>
                ) : null
        },
        {
            id: 'settings',
            label: IOT_SETTINGS_LABEL,
            render: (view) => (view.extended ? <IoTSettingsSection iot={view.extended} /> : null)
        }
    ]
};
